import { Identifiable, Resource } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function removeResourceFromPlanzone(httpClient: HttpClient) {
  return (resource: Identifiable<Resource>) =>
    httpClient
      .sendHttpRequest<void>({
        endpoint: `/resources/${resource.uuid}`,
        method: HttpMethods.DELETE,
      })
      .catch((e) => Promise.reject({ ...e, message: e.detail || "" }));
}

export { removeResourceFromPlanzone };
